import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from '../../services/vernost-service.service';

@Component({
  selector: 'app-functionality',
  templateUrl: './functionality.component.html'
})
export class FunctionalityComponent implements OnInit {
  searchlist: boolean = true;
  showList: boolean = false;
  loader: any = false;
  SearchResponce: any = [];
  screentitle: string = "Functionality Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_functionality";
  parent_table_ID = "FUN_ID";
  child_table_ID = "FUN_ID";
  childtables = [];
  childtables1 = ["mst_functionality"];
  filters = [];
  FUN_NAME = "FUN_NAME";
  Parent_result_ID = "";
  formData: any = [];
  FUN_ROUTER_NAME = "FUN_ROUTER_NAME";
  FUN_PARENT = "FUN_PARENT";
  FUN_ORDER = "FUN_ORDER";
  FUN_STATUS = "FUN_STATUS";
  combo_details1: any = [];
  IsDisable: boolean = true;
  Functionality_Status = [{
    key: 0, value: "De-Active"
  },
  {
    key: 1, value: "Active"
  }];

  APPROVAL_STATUS = "APPROVAL_STATUS";
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;

  dbFields = [this.FUN_NAME, this.FUN_ROUTER_NAME, this.FUN_PARENT, this.FUN_STATUS]
  searchitem = " ";
  searchColumn = " ";
  functionality_screen_details: any = [];

  functionality_search_details: any = [];
  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  p: number = 1;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = ""
  flag: string = "";
  constructor(private vernostService: VernostServiceService) {
  }

  ngOnInit() {

    // this.functionality_screen_details.FUN_STATUS="0"
    this.uid = localStorage.getItem('uid');
    this.roleID = localStorage.getItem('roleID');
    this.fid = localStorage.getItem("fid");
    // alert("fid"+this.fid);
    //console.log(this.fid);

    var rollArray = {
      funId: this.fid,
      roleID: this.roleID
    }
    //console.log("this.roleID ",this.roleID )
    this.vernostService.checkFunAccess(rollArray).subscribe((response) => {
      //console.log(JSON.stringify(response[0].addinfo))
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);

    })
    this.functionality_screen_details = {
      FUN_NAME: "",
      FUN_ROUTER_NAME: "",
      FUN_PARENT: 0,
      FUN_STATUS: 0,
      FUN_ORDER: ""
    }
    this.functionality_search_details = {
      FUN_NAME: "",
      FUN_ROUTER_NAME: ""

    }

    this.addCombo(this.childtables1[0], this.filters[0]);
    //this.functionality_screen_details.FUN_STATUS=100;
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    let arrayFunctionality = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    }
    this.vernostService.checkAproval(arrayFunctionality).subscribe((response) => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      } 
      else if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    })
  }
  aproveReject(status) {
    var dbFieldFunctionality = [this.APPROVAL_STATUS, this.APPROVAL_REMARKS, this.APPROVAL_BY];
    var formDataFunctionality = [status, this.aprove_details.APPROVAL_REMARKS, this.uid];
    var array = {
      dbField: dbFieldFunctionality,
      parent_table: this.parent_table,
      formData: formDataFunctionality,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    }
    //console.log(array);
    this.vernostService.aproveReject(array).subscribe((response) => {
      if (response[0].aproval == "aproved") {
        // this.aprovebtn=false;
        alert(JSON.stringify(response[0].status));
        this.searchForm();

      }
      if (response[0].aproval == "rejected") {
        // this.aprovebtn=false;
        alert(JSON.stringify(response[0].status));
        this.searchForm();

      }
      else {
        // this.rejectbtn=false;
        // alert(JSON.stringify(response[0].status));
        this.searchForm();

      }
    })
  }
  addForm() {
    document.getElementById("errs").innerHTML =
      "";
    this.flag = "Add";
    this.Parent_result_ID = "";
    this.showList = false;

    this.functionality_screen_details = {
      FUN_NAME: "",
      FUN_ROUTER_NAME: "",
      FUN_PARENT: 0,
      FUN_STATUS: 0,
      FUN_ORDER: ""
    }
    this.actionmode = "Add";
  }
  searchForm() {
    this.functionality_search_details = [];
    this.searchlist = true;
    this.flag = "";
    this.actionmode = "Search";
  }
  showFormData(formData, toggle) {
    this.IsDisable = false;
    this.Parent_result_ID = formData;

    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    }

    this.vernostService.getData(array).subscribe((response) => {
      // alert(JSON.stringify(response));

      this.functionality_screen_details = {
        FUN_NAME: response[0].result[0].FUN_NAME,
        FUN_ROUTER_NAME: response[0].result[0].FUN_ROUTER_NAME,
        FUN_PARENT: response[0].result[0].FUN_PARENT,
        FUN_STATUS: response[0].result[0].FUN_STATUS
        // FUN_ORDER:response[0].result[0].FUN_ORDER
      }

      if (toggle == "1") {
        this.showList = true;
        this.actionmode = "Add";
        //  alert(this.actionmode);
        //console.log("HERE=",JSON.stringify(this.functionality_screen_details));
      }
      if (toggle == "2") {
        this.IsDisable = true;
        this.showList = false;
        this.actionmode = "Edit";
        //alert(this.actionmode);
      }
    })
  }
  submitdata() {
    // alert(this.functionality_screen_details.FUN_PARENT)
    var FUN_NAME = this.functionality_screen_details.FUN_NAME;
    var FUN_ROUTER_NAME = this.functionality_screen_details.FUN_ROUTER_NAME;
    var PARENT = this.functionality_screen_details.FUN_PARENT;
    var FUN_STATUS = this.functionality_screen_details.FUN_STATUS;
    this.formData = [FUN_NAME, FUN_ROUTER_NAME, PARENT, FUN_STATUS];
    // var FUN_ORDER=this.functionality_screen_details.FUN_ORDER;
    if (
      (FUN_NAME == "" || FUN_NAME == undefined) &&
      (FUN_ROUTER_NAME == "" || FUN_ROUTER_NAME == undefined) &&
      (PARENT == "" || PARENT == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please Fill All Fields";
    } else {
      if (this.Parent_result_ID != "") {
        // //console.log("form Data===========",this.formData);
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          parent_table_ID: this.parent_table_ID,
          formData: this.formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid,
          PAGENAME: "FUNCTIONALITY"

        }
        this.vernostService.editData(array).subscribe((response) => {
          //  alert(JSON.stringify(response[0].status))
          if (response[0].status == "Sucessfull Updated !!!!") {
            document.getElementById("errs").innerHTML =
              "Record Updated Successfully";
            this.searchForm();
          } else {
            document.getElementById("errs").innerHTML =
              "Record Not Updated Successfully";
          }

        })

      }

      if (this.Parent_result_ID == "") {
        // //console.log("form Data===========",this.formData);
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          formData: this.formData,
          USER_ID: this.uid,
          PAGENAME: "FUNCTIONALITY"
        }
        this.vernostService.insertData(Data).subscribe((response) => {
          //  alert(JSON.stringify(response[0].status))
          if (response[0].status == "success") {
            document.getElementById("errs").innerHTML =
              "Record Inserted Successfully";
            this.searchForm();
          } else {
            document.getElementById("errs").innerHTML =
              "Record Not Inserted Successfully";
          }


        })
      }
    }


  }


  addCombo(childtable, dbField) {
    var array = {
      childtable: childtable,
      dbField: dbField
    }

    //console.log("array========"+JSON.stringify(array));
    this.vernostService.getComboData(array).subscribe((response) => {
      // console.log("PPPP",JSON.stringify(response))
      // if (response[0].status == this.childtables1[0]) {
        this.combo_details1 = response;

        // console.log("combo_details1======" , JSON.stringify(this.combo_details1));

      // }


    })
  }
  // searchData() {
  //     this.searchlist=false;
  //     this.loader=true;

  //     console.log("this.product_screen_details", this.functionality_screen_details);
  //     var field1=this.functionality_search_details.fun_name;
  //     var field2=this.functionality_search_details.fun_router_name;
  //     console.log("field1============",field1);

  //     if( field1 != ""){
  //       this.searchitem=field1;
  //       this.searchColumn=this.FUN_NAME;
  //   }else if (field2 != "") {
  //       this.searchitem = field2;
  //       this.searchColumn = this.FUN_ROUTER_NAME;

  //     }

  //   else{
  //       this.searchitem=field1;
  //       this.searchColumn=this.FUN_NAME
  //   }

  //     var Data={
  //         parent_table:this.parent_table,
  //         dbFields:this.searchColumn,
  //         searchData:this.searchitem,
  //         childtables:this.childtables,
  //         filters:this.filters  
  //     }
  //     this.vernostService.searchRecord(Data).subscribe((response) => {
  //       console.log(JSON.stringify(response))
  //       this.loader=false;

  //       this.serachtabledata=response;

  //   })
  // }

  searchData() {
    // this.searchlist = false;
    this.loader = true;

    var field1 = this.functionality_search_details.fun_name;
    var field2 = this.functionality_search_details.fun_router_name;
    // var field3 = this.search_details.COUNTRY_NAME;

    document.getElementById("errs").innerHTML = "";
    if (
      (field1 == "" || field1 == undefined) &&
      (field2 == "" || field2 == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      // this.searchlist = false;
    } else {
      // var fields1 = field1.toUpperCase();
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(field1);
        searchColumn.push(this.FUN_NAME);
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(field2);
        searchColumn.push(this.FUN_ROUTER_NAME);
      }

      // if (field3 != "" && field3 != undefined) {
      //   searchitem.push(field3);
      //   searchColumn.push("COUNTRY_NAME");
      // }

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchFunctionalityRecord(Data).subscribe(response => {
        //console.log("responsefunctionality",response);

        this.SearchResponce = response;
        if (this.SearchResponce.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;

          this.searchlist = false;

          // this.logService.create_log_masters(
          //   "'Component Name':City Master,'Action':Srarch Record,'Modified by':" +
          //     localStorage.getItem("fname"),
          //   "info"
          // );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.serachtabledata = [];
          this.searchlist = true;
          setTimeout(function () {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

}
